import CertsListSecondaryHeader from './CertsListSecondaryHeader';

export default CertsListSecondaryHeader;
